import { generateSourcesForPicture } from '@farmersdog/corgi-x';

import jpg from './about-us-hero.jpg';
import jp2 from './about-us-hero.jp2';
import webP from './about-us-hero.webp';

export const heroImages = generateSourcesForPicture({
  mobileSources: {
    webP,
    jp2,
    jpg,
  },
  desktopSources: {
    webP,
    jp2,
    jpg,
  },
});
